import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HisTrendsUtlComponent } from './his-trends-utl.component';

const histTrendsUtlRoutes: Routes = [
  {
    path: '',
    component: HisTrendsUtlComponent,
    data: { title: 'Historical Trends in Utilization' }
  }
];

@NgModule({
  imports: [RouterModule.forChild(histTrendsUtlRoutes)],
  exports: [RouterModule]
})
export class HisTrendsUtlRouting {}



// WEBPACK FOOTER //
// ./src/app/t1-his-trends-utl/his-trends-utl-routing.module.ts